module.exports = __webpack_public_path__ + "img/30290-2-80.prt.8078594b.jpg";